import { SHORTCUT_TEXT_MATERIAL_THEME_FIELDS } from '@@partner:graphql/query/textMaterial/textMaterialShortcut'
import { TextMaterialTheme, UpdateTextMaterialThemeInput } from '@@partner:types:app'
import { gql, useMutation } from '@apollo/client'

export interface UpdateTextMaterialTheme {
  updateTextMaterialTheme: TextMaterialTheme
}

export interface UpdateTextMaterialThemeVariables {
  textMaterialThemeInfo: UpdateTextMaterialThemeInput;
  upsert: boolean;
}

export const GQL_MUTATION_UPDATE_TEXT_MATERIAL_THEME = gql`
  mutation($textMaterialThemeInfo: TextMaterialThemeInput!, $upsert: Boolean!) {
    updateTextMaterialTheme(textMaterialThemeInfo: $textMaterialThemeInfo, upsert: $upsert) {
      ${SHORTCUT_TEXT_MATERIAL_THEME_FIELDS}
    }
  }
`

export const useMutateUpdateTextMaterialTheme = () =>
  useMutation<UpdateTextMaterialTheme, UpdateTextMaterialThemeVariables>(
    GQL_MUTATION_UPDATE_TEXT_MATERIAL_THEME
  )